import React, { useEffect, useState, useMemo } from 'react'
import DataTable from 'react-data-table-component'
import { useAdminStoreActions, useAdminStoreData } from '../../store/adminStore'
import { Card, Button } from 'reactstrap'
import { useTranslation } from 'react-i18next'
import Icon from '../../components/icon/Icon'
import UserSubscriptionModal from './UserSubscriptionModal'

const AdminUsers = () => {
  const { fetchUsers, setUsersPage, setUsersSize, setUsersSort, setUsersFilters } = useAdminStoreActions()
  const users = useAdminStoreData.users()
  const loading = useAdminStoreData.usersLoading()
  const totalElements = useAdminStoreData.usersTotalElements()
  const page = useAdminStoreData.usersPage()
  const size = useAdminStoreData.usersSize()

  const [filterText, setFilterText] = useState('')
  const [modalOpen, setModalOpen] = useState(false)
  const [selectedUser, setSelectedUser] = useState(null)

  const { t } = useTranslation()

  useEffect(() => {
    const timer = setTimeout(() => {
      setUsersFilters({ username: filterText })
    }, 1000)

    return () => clearTimeout(timer)
  }, [filterText, setUsersFilters])

  useEffect(() => {
    fetchUsers()
  }, [])

  const handleEditClick = (row) => {
    setSelectedUser(row)
    setModalOpen(true)
  }

  const columns = useMemo(() => [
    {
      name: t('admin.table.username', 'Username'),
      selector: row => row.userName,
      sortable: true,
      sortField: 'username',
      wrap: true
    },
    {
      name: t('admin.table.email', 'Email'),
      selector: row => row.email,
      sortable: true,
      sortField: 'email',
      wrap: true
    },
    {
      name: t('admin.table.action', 'Action'),
      button: true,
      cell: row => (
        <Button color="primary" size="sm" onClick={() => handleEditClick(row)} style={{ paddingInline: '.5rem' }}>
          <Icon name="edit" style={{ fontSize: '1rem', marginRight: '.625rem' }}/> {t('admin.table.edit', 'Edit')}
        </Button>
      )
    }
  ], [t])

  const handlePageChange = page => {
    setUsersPage(page - 1)
  }

  const handlePerRowsChange = (newPerPage, page) => {
    setUsersSize(newPerPage)
  }

  const handleSort = (column, sortDirection) => {
    if (column.sortField) {
      setUsersSort(`${column.sortField},${sortDirection}`)
    }
  }

  const paginationComponentOptions = {
    rowsPerPageText: t('admin.pagination.rowsPerPage', 'Rows per page:'),
    rangeSeparatorText: t('admin.pagination.rangeSeparator', 'of'),
    selectAllRowsItem: false,
    selectAllRowsItemText: 'All'
  }

  return (
    <div className="admin-users">
      <Card className="card-bordered card-preview">
        <div className="card-inner position-relative text-end">
          <div className="card-title-group">
            <div className="card-tools">
              <div className="form-inline flex-nowrap gx-3">
                <div className="form-control-wrap w-200">
                  <div className="form-icon form-icon-left">
                    <Icon name="search"/>
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder={t('admin.searchPlaceholder', 'Search...')}
                    onChange={(e) => setFilterText(e.target.value)}
                    style={{ width: '20rem' }}
                  />
                </div>
              </div>
            </div>
          </div>
          <DataTable
            columns={columns}
            data={users}
            progressPending={loading}
            pagination
            paginationServer
            paginationTotalRows={totalElements}
            onChangePage={handlePageChange}
            onChangeRowsPerPage={handlePerRowsChange}
            paginationDefaultPage={page + 1}
            paginationPerPage={size}
            paginationComponentOptions={paginationComponentOptions}
            sortServer
            onSort={handleSort}
            highlightOnHover
            pointerOnHover
            noDataComponent={<div className="p-2">{t('admin.table.noData', 'No records found')}</div>}
          />
        </div>
      </Card>
      {modalOpen && (
        <UserSubscriptionModal
          isOpen={modalOpen}
          toggle={() => setModalOpen(!modalOpen)}
          selectedUser={selectedUser}
        />
      )}
    </div>
  )
}

export default AdminUsers
